import legacyGetCountry from '../../legacy/views/helpers/get_country'

const getCountry = legacyGetCountry

export { getCountry }
